/*global jQuery:false */
'use strict';

function closeStoreSelect() {
    $(".fs--city-container").hide();
    $(".openCity").removeClass('active').attr('aria-expanded', 'false');
}

function manageOuterClickStoreSelect() {
    $(document).on('click', function (event) {
        let container = $('.fs-search-city')[0];
        let $containerActive = $('.fs--btn-search-city.active').length;
        if ($containerActive && container !== event.target && !container.contains(event.target)) {
            closeStoreSelect();
            return false;
        }
    });
}

const FindStoreHelper = function () {
    const _bindFindStore = function (fsSliderContainerId, fromFindStorePage) {
        const fsCityContainer = fsSliderContainerId + ' .fs--city-container';
        const fsFindButton = fsSliderContainerId + ' .find-btn';
        const fsPostalCode = fsSliderContainerId + ' #postalCode';
        const fsCityHidden = fsSliderContainerId + ' .city-hidden';
        const fsSearchCityButton = fsSliderContainerId + ' .fs--btn-search-city';
        const fsProvinceItems = fsSliderContainerId + ' .fs--province-items';
        const fsOpenCity = fsSliderContainerId + ' .openCity';

        let subPerCity = document.querySelectorAll(fsCityContainer);
        $('.ss--header .modal__close.focusable').focus();

        $(fsOpenCity).bind('click', function (e) {

            $(this).toggleClass('active');
            if ($(this).attr('aria-expanded') == 'false') {
                $(this).attr('aria-expanded', 'true');
                manageOuterClickStoreSelect();
            } else {
                $(this).attr('aria-expanded', 'false');
            }
            jQuery(subPerCity).slideToggle('fast');
            e.preventDefault();
            $(fsSliderContainerId).find('input[name=postalCode]').val('');

            let objProvCities = $.parseJSON(cityNames);

            $(fsProvinceItems).empty();
            $.each(objProvCities, function (i, item) {
                let li = $("<li><a></a></li>");
                $(fsProvinceItems).append(li);
                $("a", li).text(item);
                $("a", li).attr("href", '#');
            });

            $(fsCityContainer + ' li a[href=#]').click(function (e) {
                e.preventDefault();
                let city = $(this).text();
                $(fsCityHidden).val(city);
                let $searchCity = $(fsSearchCityButton).find('.selectedCity');
                $searchCity.text(city);
                $(fsPostalCode).val('');

                $(fsOpenCity).removeClass('active');
                $(fsCityContainer).hide();

                if ($(fsFindButton).length) {
                    $(fsFindButton).prop('disabled', false);
                }

                if (fromFindStorePage) {
                    $('.find-a-store #searchForm').trigger('submit');
                }
            });
        });
    }

    return {
        bindFindStore: _bindFindStore
    };
}();

function callStoresData() {
    $.ajax({
        url: findShoppingStoreUrl,
        type: 'GET',
        contentType: 'application/json',
        dataType: 'html',
        cache: false,
        success: function (data, code, jqXHR) {
            $('#storeSelectorContainer').html(data);
            $('.store-selector.rightPanel').removeClass('in-progress');
            $("#storeSelectorContainer #postalCode").mask('S0S 0S0');
            $("#storeSelectorContainer .find-btn").prop('disabled', true);

            if (TINK.matchMediaMobile()) {
                $("#storeSelectorContainer .fs-search-province").addClass('hide');
                $("#storeSelectorContainer .fs-search-city").addClass('hide');
                $(".mobile-open-selection").addClass('hide');
            }
            initStoreSlider();
        },
        error: function (jqXHR) {
            TINK.redirectIfConflict(jqXHR);
        }
    });
}

function initStoreSlider() {
    const fsContainerId = '#storeSelectorContainer';
    const fsBoxesShops = fsContainerId + ' .fs--boxes-shops';
    const fssForm = fsContainerId + ' #fssForm';
    const fsSearchCity = fsContainerId + ' .fs-search-city';
    const fsFindButton = fsContainerId + ' .find-btn';
    const fsPostalCode = fsContainerId + ' #postalCode';

    $(fsPostalCode).on('keyup', function () {
        let postalCodeLength = $(fsPostalCode).val().length;
        if (postalCodeLength === 7) {
            $(fsFindButton).prop('disabled', false);
        } else {
            $(fsFindButton).prop('disabled', true);
        }
    });

    $('.mobile-city-link').bind('click', function (e) {
        e.preventDefault();
        if (!$('.mobile-city-link').hasClass('active')) {
            $(fsSearchCity).removeClass('hide');
            $(".mobile-open-selection").removeClass('hide');
            $(".mobile-city-link").addClass('active');
            manageOuterClickStoreSelect();
        } else {
            $(fsSearchCity).addClass('hide');
            $(".mobile-open-selection").addClass('hide');
            $(".mobile-city-link").removeClass('active');
        }
    });

    $('.ss--footer .setMyStoreButton').off('click').on('click', onClickConfirmMyShoppingStore);
    var form = $(fssForm);
    var sectionInProgress = $('.internal.vitrine');
    form.submit(function (e) {
        e.preventDefault();
        $('#error-summary').html('');
        sectionInProgress.addClass('in-progress relative');
        $.ajax({
            type: form.attr('method'),
            url: form.attr('action'),
            data: form.serialize(),
            success: function (data) {
                sectionInProgress.removeClass('in-progress relative');
                var html = $(data);
                form.find('input').blur();

                $('#error-summary').html(html.find('#error-summary-replacement').html());
                if (html.find('#map-results-replacement').length > 0) {
                    $(fsBoxesShops).css('visibility', 'visible');
                    $(fsBoxesShops).replaceWith(html.find('#map-results-replacement')[0].outerHTML);
                    $('.fs--box-shop.radio--standard').click(function () {
                        let storeId = $(this)[0].getAttribute("data-storeid");
                        $('.ss--footer .setMyStoreButton')[0].setAttribute("data-storeid", storeId);
                        $('.ss--footer .setMyStoreButton').prop('disabled', false);
                    });
                } else {
                    $(fsBoxesShops).css('visibility', 'hidden');
                    $(fsBoxesShops).hide();
                }
                pushDataLayerSearchStore();
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    sectionInProgress.removeClass('in-progress relative');
                }
            }
        });
    });

    FindStoreHelper.bindFindStore(fsContainerId, false);
}

$(document).ready(function () {
    // open store selector only if no cart started
    if (typeof isCartAvailable !== 'undefined' && !isCartAvailable) {
        $('.sd--address-icon-cta-wrapper .openStoreLocator').addClass('hide');
        $('.sd--address-icon-cta-wrapper .setMyStoreButton').removeClass('hide');
    } else {
        $('.sd--address-icon-cta-wrapper .openStoreLocator').removeClass('hide');
        $('.sd--address-icon-cta-wrapper .setMyStoreButton').addClass('hide');
    }

    $('.user__shop span .modal-store-selector').click(function () {
        openSlider();
    });

    $('.set-fav-store .modal-store-selector').click(function () {
        openSlider();
    });

    $('#content-flyer .modal-store-selector').click(function () {
        openSlider();
    });

    function openSlider() {
        $(".ss--footer .setMyStoreButton").prop('disabled', true);
        $('.store-selector.rightPanel').addClass('in-progress');
        callStoresData();

        let $mobileBurgerMenu = $('.mm__open-menu.active');
        if ($mobileBurgerMenu.length) {
            $mobileBurgerMenu.click();
        }
    }
});